import { render } from "./xSvg.vue?vue&type=template&id=0a1b4a3a"
import script from "./xSvg.vue?vue&type=script&lang=js"
export * from "./xSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__